import React from "react";
import PropTypes from "prop-types";

const VIEWS = [
  { key: "list",     icon: "bi-list-ul",   label: "List" },
  { key: "kanban",   icon: "bi-kanban",    label: "Kanban" },
  { key: "calendar", icon: "bi-calendar3", label: "Calendar" },
];

export default function ViewSwitcher({ activeView, onChange }) {
  return (
    <div className="t2t-tab-group">
      {VIEWS.map((v) => (
        <button
          key={v.key}
          className={`t2t-tab d-flex align-items-center gap-1${activeView === v.key ? " active" : ""}`}
          onClick={() => onChange(v.key)}
          title={v.label}
        >
          <i className={`bi ${v.icon}`} style={{ fontSize: 11 }} />
          <span>{v.label}</span>
        </button>
      ))}
    </div>
  );
}

ViewSwitcher.propTypes = {
  activeView: PropTypes.string,
  onChange:   PropTypes.func.isRequired,
};
